// @flow
import React, { type Node } from 'react';
import { useTranslation } from 'react-i18next';

import Tooltip from 'app/common/ui/Tooltip';

import styles from './ClientTip.module.scss';;


type Props = {
  client: string,
  children: Node,
}

const ClientTip = ({ client, children }: Props) => {
  const { t } = useTranslation('cafeteria');

  return (
    <Tooltip
      content={
        <div>
          <div className={styles.title}>{t('client_tooltip', 'Заказчик')}</div>
          <div>{client}</div>
        </div>
      }
    >
      {children}
    </Tooltip>
  );
};

export default ClientTip;
